"use client";

import { useState } from "react";
import { UserRound } from "lucide-react";
import { cn } from "@/lib/utils";

interface CelebrityAvatarProps {
  name: string;
  src?: string;
  size?: "xs" | "sm" | "md";
  shape?: "circle" | "portrait";
  className?: string;
}

const sizeClasses = {
  xs: "h-4 w-4 text-[9px]",
  sm: "h-6 w-6 text-xs",
  md: "h-11 w-11 text-base",
};

export function getCelebrityAvatarShapeClasses(shape: "circle" | "portrait" = "circle"): string {
  return shape === "portrait"
    ? "rounded-xl object-top"
    : "rounded-full object-center";
}

export function CelebrityAvatar({ name, src, size = "sm", shape = "circle", className }: CelebrityAvatarProps) {
  const [failed, setFailed] = useState(false);
  const canShowImage = Boolean(src) && !failed;
  const shapeClasses = getCelebrityAvatarShapeClasses(shape);

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden bg-muted font-medium text-muted-foreground ring-1 ring-border",
        shapeClasses,
        sizeClasses[size],
        className
      )}
      title={name}
    >
      {canShowImage ? (
        <img
          src={src}
          alt={name}
          className={cn("h-full w-full object-cover", shape === "portrait" ? "object-top" : "object-center")}
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : size === "xs" ? (
        <UserRound className="h-3 w-3" />
      ) : (
        name.trim().slice(0, 1)
      )}
    </span>
  );
}
